/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetKeptInspirationsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type GetKeptInspirationsQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    keptInspirations?: {
      __typename?: "KeptInspirationConnection";
      nodes: Array<{
        __typename?: "KeptInspiration";
        id: string;
        contentId: string;
        contentType: Types.KeptInspirationContent;
        contentUrl: string;
        note?: string | null;
        deleted: boolean;
      }>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export const GetKeptInspirationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getKeptInspirations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keptInspirations" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "contentId" } },
                            { kind: "Field", name: { kind: "Name", value: "contentType" } },
                            { kind: "Field", name: { kind: "Name", value: "contentUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "note" } },
                            { kind: "Field", name: { kind: "Name", value: "deleted" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                            { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                            { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetKeptInspirationsQuery__
 *
 * To run a query within a React component, call `useGetKeptInspirationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeptInspirationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeptInspirationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetKeptInspirationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetKeptInspirationsQuery,
    GetKeptInspirationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetKeptInspirationsQuery, GetKeptInspirationsQueryVariables>(
    GetKeptInspirationsDocument,
    options,
  );
}
export function useGetKeptInspirationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetKeptInspirationsQuery,
    GetKeptInspirationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetKeptInspirationsQuery, GetKeptInspirationsQueryVariables>(
    GetKeptInspirationsDocument,
    options,
  );
}
// @ts-ignore
export function useGetKeptInspirationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetKeptInspirationsQuery,
    GetKeptInspirationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetKeptInspirationsQuery, GetKeptInspirationsQueryVariables>;
export function useGetKeptInspirationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetKeptInspirationsQuery, GetKeptInspirationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetKeptInspirationsQuery | undefined,
  GetKeptInspirationsQueryVariables
>;
export function useGetKeptInspirationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetKeptInspirationsQuery, GetKeptInspirationsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetKeptInspirationsQuery, GetKeptInspirationsQueryVariables>(
    GetKeptInspirationsDocument,
    options,
  );
}
export type GetKeptInspirationsQueryHookResult = ReturnType<typeof useGetKeptInspirationsQuery>;
export type GetKeptInspirationsLazyQueryHookResult = ReturnType<
  typeof useGetKeptInspirationsLazyQuery
>;
export type GetKeptInspirationsSuspenseQueryHookResult = ReturnType<
  typeof useGetKeptInspirationsSuspenseQuery
>;
export type GetKeptInspirationsQueryResult = Apollo.QueryResult<
  GetKeptInspirationsQuery,
  GetKeptInspirationsQueryVariables
>;
